import { createSelector } from "@reduxjs/toolkit";
import { AUTHOR_TYPES } from "../../../packages/constants";
import type { AppState } from "../../../store";
import type { AuthorList } from "../types";

export const selectAuthorList = createSelector(
  (state: AppState) => state.auth.user,
  (state: AppState) => state.chat.authors,
  (user, authors): AuthorList => {
    // добавляем юзера как еще одного автора,
    // если его нет в списке из загруженных сообщений
    const person = { ...user, role: AUTHOR_TYPES.USER };

    return { [person.id]: person, ...authors };
  }
);
